import { createSelector } from 'reselect';
import { creationClubsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const creationClubsYearsSelector = createSelector([creationClubsSelector], (creationClubs) =>
  extractDatesFromNestedItems(
    [creationClubs.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
